const handleTranslations = (state) => {
    // state.forms.validationMessages = translations.validationMessages
    // state.forms.errors = translations.errors
    state.translationsLoaded = true
}

const setGlobals = (state, { globals }) => {
    state.globals = globals
}

const setSeo = (state, { seo, slug }) => {
    const seoObject = {
        title: seo.MetaTitleContainer.title.title,
        description: seo.MetaTagContainer.description.content,
        ogTitle: seo.MetaTagContainer['og:title'].content,
        ogDescription: seo.MetaTagContainer['og:description'].content,
        ogImage: seo.MetaTagContainer['og:image'].content
        // twitterTitle: seo.MetaTagContainer['twitter:title'].content,
        // twitterDescription: seo.MetaTagContainer['twitter:description'].content,
        // twitterImage: seo.MetaTagContainer['twitter:image'].content
    }
    state.seo[slug] = seoObject
}

const setSeoPath = (state, { path }) => {
    state.seo.path = path
}

const setPage = (state, { result, slug }) => {
    state.page = {}
    state.page = result
}

const clearPage = (state) => {
    state.page = {}
}

const setType = (state, { type }) => {
    state.type = type
}

const setJobs = (state, { result }) => {
    state.jobs = result.data
}

const setRedirectPage = (state, { slug }) => {
    state.redirectPage = slug
}

// Export
export default {
    handleTranslations,
    setGlobals,
    setSeo,
    clearPage,
    setSeoPath,
    setPage,
    setType,
    setRedirectPage,
    setJobs
}
